import { ISO8601Type } from 'types/common.types';
import { OrderSchedule } from 'types/graphql';
import { convertTimeToHours, formatInterval } from 'utils/time';
import i18next from 'i18next';
import { DateTime } from 'luxon';
export const calculateBreakTime = (order: OrderSchedule) => {
  return formatInterval(convertTimeToHours(order?.breakTime) * 60);
};
export const calculateDuration = (totalDuration: number | null) => {
  return `${String(totalDuration)
    .split('.')
    .map((str, i) => {
      if (i === 0) return `${str} hrs`;
      if (i === 1) {
        if (str.length === 1) return `${(60 * Number.parseInt(`${str}0`, 10)) / 100} mins`;
        return `${(60 * Number.parseInt(str, 10)) / 100} mins`;
      }
      return '';
    })
    .join(' ')}`;
};

export const formatDateForShiftTableRow = (
  date: ISO8601Type,
  timeZone: string | undefined,
  showDayOfWeek: boolean,
  showTime: boolean,
) => {
  // Parse the day of the week
  let day = '';
  switch (DateTime.fromISO(date).setZone(timeZone).get('weekday')) {
    case 1:
      day = i18next.t('MON');
      break;
    case 2:
      day = i18next.t('TUE');
      break;
    case 3:
      day = i18next.t('WED');
      break;
    case 4:
      day = i18next.t('THU');
      break;
    case 5:
      day = i18next.t('FRI');
      break;
    case 6:
      day = i18next.t('SAT');
      break;
    case 7:
      day = i18next.t('SUN');
      break;
  }
  const dateFormat = showTime ? `d, yyyy '${i18next.t('common:AT')}' h:mm a` : `d, yyyy`;
  const month = DateTime.fromISO(date).setZone(timeZone).toFormat('MMM').toUpperCase();
  const TranslatedMonth = i18next.t(month);
  return showDayOfWeek
    ? `${day}, ${TranslatedMonth}, ${DateTime.fromISO(date).setZone(timeZone).toFormat(dateFormat)}`
    : `${TranslatedMonth}, ${DateTime.fromISO(date).setZone(timeZone).toFormat(dateFormat)}`;
};

export const getHoursAndMinutesFromDate = (date: ISO8601Type, timeZone: string | undefined) =>
  DateTime.fromISO(date).setZone(timeZone).toFormat('hh:mm a');
